<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <header-add
            class="col-12"
            :typeEvent="1"
            route="/works/typeabsences/create"
            v-if="isCreate()"
          />
        </div>
        <div v-if="isIndex()">
          <card-header
            @searchedQuery="searchedQuery"
            class="mr-3 mt-4"
          ></card-header>
          <master-table
            :infoTable="queriedData"
            :columns="tableColumns"
            :showColumnStatus="true"
            :widthColumnStatus="180"
          >
            <template slot="addColumns">
              <table-column-badges
                prop="businesses[0].name"
                :label="$t('common_words.associated_companies2')"
                fromData="businesses"
                textBadge="name"
                :minWidth="150"
              />
            </template>
            <template slot="addColumnsOperations">
              <table-columns-operations
                v-if="isShow() || isUpdate() || isDelete()"
                @handleView="handleView"
                @handleEdit="handleEdit"
                @handleDelete="handleDelete"
                @handleActivate="handleActivate"
                :canDisable="true"
                :minWidth="120"
              />
            </template>
          </master-table>
        </div>
        <not-index-permissions v-else />
        <card-footer ref="cardfooter" />
        <export-tables
          :pdf="{
            filename: `${$t('labor.types_of_absence')}.pdf`,
            route: 'works/typeabsences/pdf',
          }"
          :xls="{
            filename: `${$t('labor.types_of_absence')}.xlsx`,
            route: 'works/typeabsences/excel',
          }"
        />
        <br />
      </card>
      <el-dialog
        v-if="isShow()"
        :title="$t('labor.types_of_absence')"
        :visible.sync="modals.read"
        width="64%"
        top="2%"
      >
        <div class="card" v-if="rowData">
          <div class="card-body" v-if="rowData">
            <table class="table">
              <tbody>
                <tr class="shadow-sm">
                  <td>
                    <h6 class="mb-2">
                      <strong>{{ $t('common_words.code') }}:</strong>
                    </h6>
                    {{ rowData.code }}
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td>
                    <h6 class="mb-2">
                      <strong>{{ $t('common_words.name') }}:</strong>
                    </h6>
                    {{ rowData.name }}
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td>
                    <h6 class="mb-2">
                      <strong>{{ $t('labor.minimum_time') }}:</strong>
                    </h6>
                    {{ rowData.minimum }}
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td>
                    <h6 class="mb-2">
                      <strong>{{ $t('labor.maximum_time') }}:</strong>
                    </h6>
                    {{ rowData.maximum }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <h6 class="mb-2">
                      <strong>{{ $t('labor.aproval') }}:</strong>
                    </h6>
                    {{ rowData.approval }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <h6 class="mb-2">
                      <strong>{{ $t('common_words.description') }}:</strong>
                    </h6>
                    {{ rowData.description }}
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td>
                    <h6 class="mb-2">
                      <strong>{{ $t('common_words.companies2') }}:</strong>
                    </h6>
                    <span
                      v-for="(business, index) in rowData.businesses"
                      :key="index"
                    >
                      <el-tag type="info">{{ business.name }}</el-tag>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-footer footer-date-at" v-if="rowData">
            <p class="text-white">
              <small
                >{{ $t('common_words.created_on') }}:
                {{ rowData.created_at }}</small
              >
            </p>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { MixinExport } from 'src/mixins/mixin-export';
import { Pagination as LPagination } from 'src/components/index';
import configTable from './type-absences-table';
import Fuse from 'fuse.js';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    LPagination,
  },
  computed: { ...configTable().Search },
  data() {
    return {
      model: {
        id: null,
        name: null,
        code: null,
        minimum: null,
        maximum: null,
        approval: null,
        state: null,
        description: null,
        businesses_id: [],
      },
      businesses: [],
      pagination: {},
      tableColumns: [],
    };
  },
  mixins: [MixinMasters, MixinPermissions, MixinMenu, MixinExport],

  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    handleView(_, row) {
      this.rowData = { ...row };
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.modals['read'] = true;
    },

    handleEdit(_, row) {
      this.editForm = { ...row };
      sessionStorage.setItem('editForm', JSON.stringify(this.editForm));
      this.$router.push({
        path: '/works/typeabsences/edit',
      });
    },

    handleDelete(_, row) {
      this.model = { ...row };
      SweetAlert.disable(
        `${i18n.t('sweet_alert.sowing.deactivate_sowing_method')}?`
      ).then((result) => {
        if (result.value) this.deleteTypeAbsence();
      });
    },

    handleActivate(_, row) {
      this.model = row;
      SweetAlert.default(
        `${i18n.t('sweet_alert.sowing.activate_sowing_method')}?`,
        null,
        i18n.t('common_words.yes_enable'),
        1
      ).then((result) => {
        if (result.value) this.activateTypeAbsence();
      });
    },

    activateTypeAbsence() {
      if (this.isUpdate()) {
        this.showHideLoading(true);
        this.model.route = 'works/typeabsences/activate';
        Axios.updateMaster(this.model)
          .then((response) => this.modifyTable(1, this.model.id, response))
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    deleteTypeAbsence() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.model.route = 'works/typeabsences';
        Axios.destroyMaster(this.model)
          .then((response) => {
            this.modifyTable(1, this.model.id, response);
          })
          .catch((error) => this.showMessageErrors(error));
      }
    },
    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);
      Promise.all([
        Axios.getMasters('works/typeabsences'),
        Axios.getMasters('businesses/only'),
      ])
        .then((response) => {
          const [responseTypeabsences, respondeBusinesses] = response;
          this.tableData = responseTypeabsences.data.data;
          this.businesses = this.concatAll(respondeBusinesses.data.data);
          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumns.map((prop) => {
              return prop.prop;
            }),
          });

          const codesOn = this.tableData
            .map((data) => Number(data.code.replace(/\D/g, '')))
            .sort((a, b) => b - a)
            .filter((code) => !isNaN(code));

          sessionStorage.setItem('tableCode', JSON.stringify(codesOn));

          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }
  },
  mounted() {
    this.selectedItemOnMenu('works');
  },

  destroyed() {
    this.deselectedItemOnMenu('works');
  },
};
</script>
